import { CheckCircle2, Globe } from 'lucide-react';
import { useDocxBuilder } from './context';
import { VariableOverview } from './selection/VariableOverview';

export function DocxBuilderStepPublish() {
  const { available } = useDocxBuilder();

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <CheckCircle2 className="h-6 w-6 text-lime-green shrink-0" />
        <div>
          <p className="font-medium text-[hsl(var(--fg))]">Template ready</p>
          <p className="text-sm text-globe-grey">
            {'Word document'} &bull;{' '}

          </p>
        </div>
      </div>

      {available ? (
        <div className="flex items-center gap-2 text-sm text-[hsl(var(--fg))]">
          <Globe className="h-4 w-4 text-lime-green" />
          Published to your organization
        </div>
      ) : (
        <p className="text-sm text-globe-grey">
          It&apos;s saved as a draft. Use the panel on the right to publish it to your
          organization.
        </p>
      )}

      {/* Read-only overview of the fields colleagues will fill in. */}
      <VariableOverview />
    </div>
  );
}
